module.exports = __webpack_public_path__ + "img/logo.b7e53b92.png";